export * from './components/SensitivityLabel/index';
//# sourceMappingURL=SensitivityLabel.js.map